import { render, staticRenderFns } from "./orderNote.vue?vue&type=template&id=541b6da4&"
import script from "./orderNote.vue?vue&type=script&lang=js&"
export * from "./orderNote.vue?vue&type=script&lang=js&"
import style0 from "./orderNote.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports